import { render, staticRenderFns } from "./ChatTabPanel.vue?vue&type=template&id=00cb4a8d&scoped=true&"
import script from "./ChatTabPanel.vue?vue&type=script&lang=js&"
export * from "./ChatTabPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00cb4a8d",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ChatFriend: require('/home/runner/work/mywellness-fiesta-2026/mywellness-fiesta-2026/user/components/chat/ChatFriend.vue').default,ChatMessage: require('/home/runner/work/mywellness-fiesta-2026/mywellness-fiesta-2026/user/components/chat/ChatMessage.vue').default})
